module.exports = "https://r.zoocdn.com/_next/static/images/selected-sold-property-cluster-pin-488b9cc467f045de5dc3de3453fca809.svg";